import { render, staticRenderFns } from "./AlbaranStatsPage.vue?vue&type=template&id=5b83d01c&scoped=true"
import script from "./AlbaranStatsPage.vue?vue&type=script&lang=js"
export * from "./AlbaranStatsPage.vue?vue&type=script&lang=js"
import style0 from "./AlbaranStatsPage.vue?vue&type=style&index=0&id=5b83d01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83d01c",
  null
  
)

export default component.exports